import { IconButton, Icon, Tooltip } from '@chakra-ui/react'
import { FiRefreshCw } from 'react-icons/fi'

export const ButtonRefresh = (props: {
  isDisabled?: boolean;
  onClick: () => void;
}) => {
  return (
    <Tooltip label="Refresh" aria-label="Refresh">
      <IconButton
        onClick={props.onClick}
        aria-label="Refresh"
        isDisabled={props.isDisabled}
        variant='ghost'
        icon={<Icon as={FiRefreshCw} />}
      />
    </Tooltip>
  )
}